import { Component, OnInit } from '@angular/core';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-mie-tables',
  templateUrl: './mie-tables.component.html',
  styleUrls: ['./mie-tables.component.css']
})
export class MieTablesComponent implements OnInit {
    public grid?: GridOptions;

    public updating = false;

    constructor(private modal: ModalService, private datatask: DataTaskService) {

    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('mietable_grid')
                .setLoadDataFunction({
                    method: 3597,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async updateChanges() {
        try {
            this.updating = true;

            const response = (await this.datatask.Post(3598))[0];

            if (response?.errorcode !== '0') {
                this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.errormessage
                });
            } else {
                this.loadGrid();
            }
        } finally {
            this.updating = false;
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
